import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/components/ui/button/button';
import { TFormDateTimePickerActionBarProps } from '@/shared/components/ui/form/components/form-date-time-picker/components/form-date-time-picker-action-bar/form-date-time-picker-action-bar.types';

export const FormDateTimePickerActionBar: React.FC<
  TFormDateTimePickerActionBarProps
> = ({ value, onChange, handleClose }) => {
  const { t } = useTranslation();

  const handleClear = () => {
    onChange?.(null);
    handleClose?.();
  };

  const handleAccept = () => {
    handleClose?.();
  };

  if (!onChange || !handleClose) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      gap="0.75rem"
      gridColumn="1 / 4"
      gridRow="3"
      marginTop="1rem"
    >
      {!!value && (
        <Button size="extraSmall" variant="secondary" onClick={handleClear}>
          {t('ui:clear')}
        </Button>
      )}
      <Button size="extraSmall" variant="primary" onClick={handleAccept}>
        {t('ui:accept')}
      </Button>
    </Stack>
  );
};
